import axios from 'axios';

export default class ValidationService {
  constructor(csrfToken) {
    this.csrfToken = csrfToken;
  }

  validate = async (googlePlacesId) => {
    // validate that the selected google place id is unique in our system
    return axios.post(
      '/signup/validate',
      {
        google_places_id: googlePlacesId,
        csrfmiddlewaretoken: this.csrfToken,
      },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
  };
}
